import {Response} from "@/hooks/services/queries/types";
import logger from "@FRAMEWORK/utils/logger";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

type GlobarOpt = {
	menuOrder: number;
	mobileAttaFileKey: string;
	mobileMenuNm: string;
	mobileMenuUrl: string;
	mobileNewWindowYn: string;
	pcAttaFileKey: string;
	pcMenuNm: string;
	pcMenuUrl: string;
	pcNewWindowYn: string;
	regDt: string;
	regId: number;
	seq: number;
	updDt: string;
	updId: number;
	useYn: string;
	webMenuTarget: "NEW" | "SELF";
	mwebMenuTarget: "NEW" | "SELF";
};

/** ```
 * 공통 운영 메뉴 조회 API
 *   `/global/opt/list`
 * ```*/
const key = "useGlobalOpt";
const getPath = (): string | null => `/bff/global/opt`;

/** ```
 * 공통 운영 메뉴 조회 API
 *   `/global/opt/list`
 * ```*/
const useGlobalOpt = (options?: Partial<UseQueryOptions<Response<GlobarOpt[]>, Error>>) => {
	try {
		return useQuery({
			queryKey: [key, getPath()],
			queryFn: () => useConfigureAxios.get(getPath()).then(r => r.data),
			gcTime: Infinity,
			staleTime: Infinity,
			throwOnError: true,
			...options,
		});
	} catch (error) {
		logger.error(error);
	}
};

export default useGlobalOpt;
export {getPath};
export type {GlobarOpt};
